import { makeStyles } from "tss-react/mui"
import { Box, Stack, Tooltip } from "@mui/material"
import { faHeart } from "@fortawesome/pro-solid-svg-icons"
import { faHeart as faHeartBorder } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { ActionButton } from "../../shop/header/ActionButton"
import { FilterSearch } from "../../FilterSearch"

const useStyles = makeStyles()((theme) => ({
    favoriteActive: {
        color: theme.palette.tailwind.blue[500],
        transition: "all 0.3s ease-out",
        "&:hover": {
            color: theme.palette.tailwind.blue[600],
        },
    },
}))

type TakeawayActionButtonsProps = Readonly<{
    search: string
    showFavorites: boolean
    onSearchChange: (search: string) => void
    onFavoritesChange: (show: boolean) => void
}>

export function TakeawayActionButtons({
    search,
    showFavorites,
    onSearchChange,
    onFavoritesChange,
}: TakeawayActionButtonsProps) {
    const { classes } = useStyles()

    return (
        <Stack flexDirection="row" alignItems="center" flex="none" gap=".75rem">
            <FilterSearch search={search} setSearch={onSearchChange} defaultActive activeWidth="18rem" />
            <LocalizedStrict
                id={showFavorites ? "create-order-favorite-show-all-products" : "create-order-favorite"}
                attrs={{ title: true }}
            >
                <Tooltip title="">
                    <Box>
                        <ActionButton
                            icon={showFavorites ? faHeart : faHeartBorder}
                            handleButtonClick={() => onFavoritesChange(!showFavorites)}
                            updateClassName={showFavorites ? classes.favoriteActive : ""}
                        />
                    </Box>
                </Tooltip>
            </LocalizedStrict>
        </Stack>
    )
}
